import React, {Suspense} from 'react';
import SpinnerCustom from "@ui/spinner/SpinnerCustom";
import PageLayout from "@view/layout/pageLayout/PageLayout";
import {
    ReportScheduleExecutionByRoutesLazy
} from "@containers/reports/readyReports/reportScheduleExecution/ReportScheduleExecutionByRoutes.lazy";

const ReportScheduleExecutionByRoutesPage = () => {
    return (
        <PageLayout>
            <Suspense
                fallback={<SpinnerCustom/>}
            >
                <ReportScheduleExecutionByRoutesLazy/>
            </Suspense>
        </PageLayout>
    );
};

export default ReportScheduleExecutionByRoutesPage;